import { getEquipmentSuffix } from "../../utils/utils";
import {
  DRIVER_EVENTS,
  Drop_Hook_Move_Page_Names,
  DROP_TRAILER_TYPE,
} from "../constants";

const isTrailerDropFieldVisible = (field, dropType, data = {}) => {
  switch (field) {
    case "selectedCustomer":
      return ![DROP_TRAILER_TYPE.TemporaryLocation, DROP_TRAILER_TYPE.AgentInterline].includes(dropType);
    case "customerName":
      return (
        data.selectedCustomer?.value === "other" &&
        ![DROP_TRAILER_TYPE.TemporaryLocation, DROP_TRAILER_TYPE.AgentInterline].includes(dropType)
      );
    case "agentDetail":
      return dropType === DROP_TRAILER_TYPE.AgentInterline;
    case "locationName":
      return dropType === DROP_TRAILER_TYPE.TemporaryLocation;
    case "receiverName":
      return [DROP_TRAILER_TYPE.CustomerDelivery, DROP_TRAILER_TYPE.AgentInterline].includes(dropType);
    default:
      return false;
  }
};

const canAddTrailer = (
  attachedTrailersCount,
  hookedTrailersCount,
  maxAllowedTrailerCount
) => {
  return (
    attachedTrailersCount >= maxAllowedTrailerCount ||
    attachedTrailersCount + hookedTrailersCount >= maxAllowedTrailerCount
  );
};

const canAddDolly = ({
  attachedDolliesCount = 0,
  hookedDolliesCount,
  maxAllowedDolliesCount
}) => {
  return (
    attachedDolliesCount >= maxAllowedDolliesCount ||
    attachedDolliesCount + hookedDolliesCount >= maxAllowedDolliesCount
  );
};

const getArrivedAtStopId = (routeData) => {
  return routeData.currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop
    ? routeData.currentStatus?.stopId
    : null;
};

const getPageDetails = (pageName) => {
  return {
    isDropHookPage: pageName === Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    isTrailerDropFormPage: pageName === Drop_Hook_Move_Page_Names.TRAILER_DROP,
    isSelectShipmentPage: pageName === Drop_Hook_Move_Page_Names.MOVE_BILLS,
  };
};

const getTrailerOptions = (trailerList, showTrailerScac) => {
  return trailerList.map(
    ({ trailerNumber, trailerId, trailerStatus, trailerScac, isStraightTruck }) => ({
      label: trailerNumber,
      value: trailerNumber,
      trailerStatus,
      trailerScac,
      trailerId,
      isStraightTruck,
      labelSuffix: getEquipmentSuffix({
        equipmentScac: trailerScac,
        equipmentStatus: trailerStatus,
        showTrailerScac,
      }),
    })
  );
}

const getDollyOptions = (dollyList, showTrailerScac) => {
  return dollyList.map(
    ({ dollyNumber, dollyId, dollyStatus, dollyScac }) => ({
      label: dollyNumber,
      value: dollyNumber,
      dollyStatus,
      dollyScac,
      dollyId,
      labelSuffix: getEquipmentSuffix({
        equipmentStatus: dollyStatus,
        equipmentScac: dollyScac,
        showTrailerScac,
      }),
    })
  )
}

const getNewHookedDolly = () => ({
  trailerNumber: null,
  trailerScac: null,
  dollyNumber: null,
  dollyScac: null,
  dollyStatus: null,
});

const getInitialHookStateData = () => {
  return [
    {
      hookDolly: getNewHookedDolly(),
      hookDollyError: null
    }
  ];
}


const checkValidDollyNumber = ({hookDollies, dollyId, dollyStatus, allowedDollyStatusesToHook}) => {
  if (!dollyId) {
    return '* Required';
  }
  const selectedDollies =
    hookDollies?.filter((dolly) => dollyId && dolly.hookDolly.dollyId === dollyId) ?? [];
  if (selectedDollies?.length > 1) {
    return 'Duplicate dolly entry';
  } else if (dollyStatus && !allowedDollyStatusesToHook.includes(dollyStatus)) {
    return `Valid dolly status: ${
      allowedDollyStatusesToHook.length === 0 ? 'None' : allowedDollyStatusesToHook.join(', ')
    }`;
  }
  return null;
};

const getCurrentDollies = (currentDriverRoutes) => {
  return currentDriverRoutes
    .filter((route) => route.dollyNumber)
    .map(({ dollyNumber, dollyScac }) => ({
      dollyNumber,
      dollyScac
    }));
};

export {
  isTrailerDropFieldVisible,
  canAddTrailer,
  getArrivedAtStopId,
  getPageDetails,
  getTrailerOptions,
  getDollyOptions,
  canAddDolly,
  getNewHookedDolly,
  checkValidDollyNumber,
  getCurrentDollies,
  getInitialHookStateData,
};
